import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import SalesHeader from "../../components/sales/SalesHeader";
import SalesStats from "../../components/sales/SalesStats";
import SalesTable from "../../components/sales/SalesTable";
import AbandonedCartsTable from "../../components/sales/AbandonedCartsTable";
import { useSalesData } from "../../hooks/useSalesData";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";

const SalesPage = () => {
  const { orders, filteredOrders, isLoading, activeFilter, activeDateFilter, activeProductFilters, confirmationStatuses, isLoadingStatuses, filterOrders, filterByDate, clearDateFilter, deleteOrder, filterByProductId, removeProductFilter, filterByFunnel, removeFunnelFilter, activeFunnelFilters, products, pagination, setPage, setPageSize, activeCountryFilter, filterByCountryCode, activeSearch, activeSort, setSearchTerm, setSortBy, refreshOrders } = useSalesData();
  const [activeTab, setActiveTab] = useState<"orders" | "abandoned">("orders");
  const [searchParams] = useSearchParams();
  const { language } = useAuth();
  const countryOptions = Array.from(
    new Set(
      (orders?.available_countries || filteredOrders?.available_countries || [])
        .map((item) => item.country_code)
        .filter(Boolean) as string[]
    )
  );
  const selectedCountryCode = activeCountryFilter && countryOptions.includes(activeCountryFilter)
    ? activeCountryFilter
    : null;
  const isOrderDetailOpen = activeTab === "orders" && Boolean(searchParams.get("order"));

  return (
    <div
      className={`min-h-screen bg-[#F5F6FA] pt-10 pb-16 font-['Plus_Jakarta_Sans'] transition-[padding] duration-200 ${
        isOrderDetailOpen ? "pl-5 pr-[499px]" : "pl-16 pr-16"
      }`}
    >
      <Toaster position="top-right" />
      <SalesHeader />

      <div className="mb-5 flex items-center justify-between gap-3">
        <div className="bg-gray-200 rounded-full p-1 flex w-fit">
          <button
            onClick={() => setActiveTab("orders")}
            className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              activeTab === "orders"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {dictionary["orders-tab"]?.[language]}
          </button>
          <button
            onClick={() => setActiveTab("abandoned")}
            className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              activeTab === "abandoned"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {dictionary["abandoned-carts-tab"]?.[language]}
          </button>
        </div>

        {activeTab === "orders" && filteredOrders && (
          <div className={isOrderDetailOpen ? "mr-4" : ""}>
            <SalesStats
              summary={filteredOrders.summary}
              selectedCountryCode={selectedCountryCode}
              orderCount={pagination?.total_items ?? filteredOrders.orders.length}
              compact
            />
          </div>
        )}
      </div>

      {activeTab === "orders" && (
        <div>
            <SalesTable
              filterOrders={filterOrders}
              orders={filteredOrders?.orders ?? []}
              activeFilter={activeFilter}
              isLoading={isLoading}
              onOrderDeleted={deleteOrder}
              onFilterByDate={filterByDate}
              activeDateFilter={activeDateFilter}
              onRemoveDateFilter={clearDateFilter}
              products={products}
              onFilterByProductId={filterByProductId}
              activeProductFilters={activeProductFilters}
              onRemoveProductFilter={removeProductFilter}
              onFilterByFunnel={filterByFunnel}
              activeFunnelFilters={activeFunnelFilters}
              onRemoveFunnelFilter={removeFunnelFilter}
              confirmationStatuses={confirmationStatuses}
              isLoadingStatuses={isLoadingStatuses}
              pagination={pagination}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
              activeCountryFilter={selectedCountryCode}
              countryOptions={countryOptions}
              onFilterByCountryCode={filterByCountryCode}
              onRefreshOrders={refreshOrders}
              activeSearch={activeSearch}
              onSearch={setSearchTerm}
              activeSort={activeSort}
              onSort={setSortBy}
            />
        </div>
      )}

      {activeTab === "abandoned" && <AbandonedCartsTable />}
    </div>
  );
};

export default SalesPage;
